import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useAuth } from "../../../hooks/useAuth";
import DriverCard from "../../Drivers/Show/DriverCard";
import DriversTable from "./Drivers";
import { useCrumbs } from "../../../hooks/useCrumbs";
import { SidebarContainer } from "../../../components";
import { EditableText } from "../../../shared";
import OrgJobs from "./Jobs/OrgJobs";
import OrgPayouts from "./Payouts/OrgPayouts";
import OrgManifests from "./Manifests/OrgManifests";
import Tabs from "../../../shared/Tabs";
import { selectAllPayouts } from "../../../redux/reducers/payouts/payoutsSlice";
import {
  useGetOrganizationQuery,
  useUpdateOrganizationMutation,
} from "../../../redux/services/organizations/organizationsApi";

const OrgShow = (props) => {
  const params = useParams();
  const { user } = useAuth();
  const crumbs = useCrumbs();

  const {
    data: orgData,
    isLoading: isOrgLoading,
    isFetching: isOrgFetching,
  } = useGetOrganizationQuery(
    { id: params.id, parent: user?.parentCompany },
    { skip: !params.id || !user?.parentCompany }
  );

  const [updateOrg] = useUpdateOrganizationMutation();

  const payouts = useSelector(selectAllPayouts);
  const payoutsStatus = useSelector((state) => state.payouts.status);

  useEffect(() => {
    if (isOrgLoading || isOrgFetching) {
      crumbs.setLoading(true);
    }
  }, [isOrgLoading, isOrgFetching]);

  useEffect(() => {
    if (orgData?._id) {
      crumbs.updateCrumbName({
        name: orgData.name,
        path: "/organizations/" + orgData._id,
      });
      crumbs.setLoading(false);
    }
  }, [orgData?._id]);

  async function handleUpdate(e) {
    const update = {
      ...e,
    };

    if (e.fullName) {
      update.name = e.fullName;
      update.organization = e._id;
    }

    await updateOrg({ id: params.id, data: update }).unwrap();

    // if (resUpdate.status === "success") {
    //   dispatch(driverUpdated(resUpdate.data));
    // }
  }

  const headerRef = useRef();
  const [headerContext, setHeaderContext] = useState();
  useEffect(() => {
    setHeaderContext(headerRef.current);
  }, [headerRef.current]);

  const renderHeader = (headerProps) => {
    return (
      <div ref={headerRef} className="p-2 border-b bg-white">
        {headerProps.title}
      </div>
    );
  };

  const tabs = [
    {
      id: "Info",
      content: (
        <div className="h-auto">
          <div className="grid grid-cols-8 gap-3">
            <DriverCard
              handleUpdate={handleUpdate}
              info={{
                ...orgData,
                fullName: orgData?.name,
                org: true,
                avatar: orgData?.avatar
                  ? orgData.avatar
                  : "https://ui-avatars.com/api/?name=" + orgData?.name,
              }}
            />
            <DriversTable
              update={handleUpdate}
              org={orgData}
              data={orgData?.employees || []}
            />
            {/* <Card className="col-span-3">
              <JobChart data={reportData} />
            </Card> */}
            {/* <DriverPayouts
              driver={driver}
              driverStatus={driverStatus}
              payouts={payouts}
              payoutsStatus={payoutsStatus}
            /> */}
            {/* <DriverJobs driver={driver} driverStatus={driverStatus} /> */}
          </div>
        </div>
      ),
    },
    // {
    //   id: "Jobs",
    //   content: (
    //     <div className="h-auto">
    //       <OrgJobs organization={orgData} driver={orgData} />
    //     </div>
    //   ),
    // },
    {
      id: "Payouts",
      content: (
        <div className="h-auto">
          <OrgPayouts
            organization={orgData}
            driver={orgData}
          />
        </div>
      ),
    },
    {
      id: "Manifests",
      content: (
        <div className="h-auto">
          <OrgManifests organization={orgData} />
        </div>
      ),
    },
  ];

  const title = (
    <div className="text-gray-800 font-semibold text-lg flex items-center">
      <EditableText
        className="ml-1"
        iconClasses="h-3 w-3"
        id="name"
        value={orgData?.name}
        size="sm"
        displayText={(v) => (
          <span className="text-gray-800 font-semibold text-lg">{v}</span>
        )}
        // loading={modalLoad}
        onSave={(e) => handleUpdate({ ...e.data, name: e.value })}
      />
    </div>
  );

  return (
    <SidebarContainer title={title} header={renderHeader} hideSidebar>
      {({ parentHeight, parentWidth }) => {
        const offsetTop = headerContext?.offsetTop;
        const offsetHeight = headerContext?.offsetHeight;
        const wrapperStyle = { height: `${parentHeight - offsetTop}px` };
        const panelStyle = {
          height: `${parentHeight - offsetTop - offsetHeight - 70}px`,
        };
        return (
          <Tabs
            className={`w-full overflow-hidden`}
            style={wrapperStyle}
            panelStyle={panelStyle}
            useSearchParams
            panelClasses={`p-2 border-t overflow-y-scroll`}
            tabListClasses="bg-white px-2 h-[38px]"
            tabclassName="mx-1"
            id="organization-show"
            // onClick={handleTabClick}
            data={tabs}
          />
          // <div className="px-3 pb-3 h-auto">
          //   <div className="grid grid-cols-8 gap-3">
          //     <DriverCard
          //       handleUpdate={handleUpdate}
          //       info={{
          //         ...org.data,
          //         fullName: org.data.name,
          //         org: true,
          //         avatar: org.data.avatar
          //           ? org.data.avatar
          //           : "https://ui-avatars.com/api/?name=" + org.data.name,
          //       }}
          //     />
          //     <DriversTable
          //       update={handleUpdate}
          //       org={org.data}
          //       data={org.data.employees || []}
          //     />
          //   </div>
          // </div>
        );
      }}
    </SidebarContainer>
  );
};

export default OrgShow;
